import { render, staticRenderFns } from "./HeaderTop.vue?vue&type=template&id=56ae82ec&scoped=true"
import script from "./HeaderTop.vue?vue&type=script&lang=ts"
export * from "./HeaderTop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae82ec",
  null
  
)

export default component.exports